import React, { useEffect, Fragment, useState } from "react";
import { Button, Container, Row, Col } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import FadeIn from "react-fade-in/lib/FadeIn";
import { isInteger, isNull, isString } from "lodash";
const REACT_APP_API_E_OFFICE = process.env.REACT_APP_API_E_OFFICE;
const REACT_APP_API_CORS = process.env.REACT_APP_API_CORS;

function ApiTesting() {
    const userEofficeAccessToken = GetCookieToken("userEofficeAccessToken");
    const [loading, setLoading] = useState(false);
    const [headersKey, setHeadersKey] = useState([]);
    const [bodyData, setbodyData] = useState([]);
    const [data, setData] = useState();
    const getData = async (type) => {
        setLoading(true)
        const arrType = [
            '/api/gateway/saraban/personal_list',
            '/api/gateway/room_booking/booking_list',
            '/api/gateway/car_reservation/reserve_list'
        ]
        const url = `${REACT_APP_API_CORS}/e-office/proxy?url=${REACT_APP_API_E_OFFICE}${arrType[(type - 1)]}`;
        const config = {
            headers: {
                Authorization: `${userEofficeAccessToken}`,
                "Content-Type": "application/x-www-form-urlencoded",
                "Access-Control-Allow-Origin": "*",
                'Access-Control-Allow-Credentials': true
            }
        }
        await axios.get(url, config).then(async response => {
            setData(response.data)
            setLoading(false)
        }).catch(error => {
            setData({ message: error.message })
            setLoading(false);
        });
    }

    useEffect(() => {
        if (data?.data?.[0]) {
            let key = Object.keys(data?.data?.[0]);
            setHeadersKey(key)
            setbodyData(data?.data)
        } else {
            setHeadersKey([])
            setbodyData([])
        }
    }, [data])

    return (
        <Fragment>
            <FadeIn>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumb title="หน้าหลัก" breadcrumbItem={`api testing`} />
                        <div className="d-xl-flex">
                            <div className="w-100">
                                <div className="d-md-flex">
                                    <div className="w-100 mb-3 card p-3 shadow">
                                        <Row className="mb-2">
                                            <Col className="d-flex p-1 px-3">
                                                <Button color="primary" className="me-1" disabled={loading} onClick={() => getData(1)}>
                                                    {loading && <i class="fa-duotone fa-spinner-third fa-spin me-1"></i>}รายชื่อเอกสารแฟ้มส่วนบคุคล
                                                </Button>
                                                <Button color="primary" className="me-1" disabled={loading} onClick={() => getData(2)}>
                                                    {loading && <i class="fa-duotone fa-spinner-third fa-spin me-1"></i>}รายการการจองห้อง
                                                </Button>
                                                <Button color="primary" className="me-1" disabled={loading} onClick={() => getData(3)}>
                                                    {loading && <i class="fa-duotone fa-spinner-third fa-spin me-1"></i>}รายการการจองรถ
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col className="" style={{ overflow: 'auto' }} >

                                                <table className="w-100 table table-sm table-bordered bordered-dark table-striped table-info table-hover">
                                                    <thead>
                                                        <tr>
                                                            {headersKey && headersKey.map(x => <th>{x}</th>)}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {bodyData && bodyData.map(x => <tr>
                                                            {headersKey && headersKey.map(y => <td>{isString(x[y]) || isInteger(x[y]) || isNull(x[y]) ? x[y] : toString(x[y])}</td>)}
                                                        </tr>)}
                                                    </tbody>
                                                </table>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </FadeIn >
        </Fragment >
    );
}

export default ApiTesting;
